import RecapPurchaseHistory from 'components/Content/Recap/RecapPurchaseHistory/RecapPurchaseHistory';

export default RecapPurchaseHistory;
